<template>
    <div class="w-full h-full">
        <form v-if="emailAddresses.length > 0" @submit.prevent="makeEmailWhitelisted" class="p-2 flex flex-col justify-between h-full" action="">
            <div class="flex flex-col w-full  mb-2">
                <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                    Email Address:
                </label>
                <select v-model="selectedEmail" class="border border-gray-300 outline-none hover:border-gray-400 active:border-indigo-400 focus:border-indigo-400 h-9 w-full" >
                    <option v-for="email in emailAddresses" :key="email.id" :value="email">{{ email.email_address }} ({{ email.description }})</option>
                </select>
            </div>
            <!-- <div class="grid grid-cols-4 gap-2 w-full">
                <div class="col-span-4">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                            Email Address:
                    </label>
                </div>
                <div :class="{'bg-blue-200' : selectedEmail && email.id == selectedEmail.id}" class="p-2 flex items-center rounded-md border border-gray-400 h-8 w-full" v-for="email in emailAddresses" :key="email.id">
                    <div class="w-1/4 flex items-center">
                        <input name="selectedEmail" type="radio" v-model="selectedEmail" :value="email">
                    </div>
                    <div class="w-3/4 flex items-center">
                        {{ email.email_address }}
                    </div>
                </div>
            </div> -->
            <div class="flex flex-col w-full mt-2" v-if="selectedEmail">
                <div class="flex flex-col  mb-2">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                        Allowed Username:
                    </label>
                    <input type="text" required placeholder="user-name" class="p-1 border h-full w-full" v-model="selectedEmail.allowed_username">
                </div>
                <div class="h-full w-full flex flex-col">
                    <label class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">
                        Registration Email Message: <base-button @click.prevent="resetEmailBody">Reset</base-button>
                    </label>
                    <rich-text-editor
                        class="bg-white w-full overflow-y-auto rounded-md border border-gray-300 relative h-[calc(100%-12rem)]"
                        v-model="emailBody"
                    />
                </div>
            </div>
            <div class="flex items-center justify-center w-full">
                <base-button-affirmative v-if="selectedEmail" class="m-2">Send</base-button-affirmative>
                <base-button-disabled v-else class="m-2">Send</base-button-disabled>
                <base-button-negative @click.prevent="closeForm" class="m-2">Cancel</base-button-negative>
            </div>
        </form>
        <div v-else class="p-2 text-base">
            No email addresses associated with this person
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { whitelistEmail } from '@/services/PersonEmail';
import RichTextEditor from '../base-components/RichTextEditor.vue';

const props = defineProps(['person'])
const emit = defineEmits(['close', 'refetch-people'])
const store = useStore()
const $toast = useToast()

const emailAddresses = computed(() => {
    return props.person.email_addresses
})

const defaultEmailMessage = ref(`<p>Hello ${props.person.first_name},</p><p></p><p>You are receiving this email because your email has been approved for an account in Shedd Capital's Aerocle system.</p><p></p><p><span style="color: rgb(0, 0, 0);"><strong>Action Steps:</strong></span></p><ol><li style="color: rgb(0, 0, 0);"><p><strong>Register</strong>:&nbsp;Click here to register on Aerocle: <a target="_blank" rel="noopener noreferrer nofollow" href="https://aerocle.sheddcapital.com/register"><span style="color: rgb(48, 191, 137);">https://aerocle.sheddcapital.com/register</span></a></p><ul><li style="color: rgb(0, 0, 0);"><p><strong>Important Note:</strong>&nbsp;Please use this email address to register for your account.</p></li></ul></li><li><p><strong>Profile Setup: </strong>Once registered, log in and set up your profile.</p><ul><li><p>Once logged in, navigate to the Profile page by clicking on your name in the top right and selecting ‘Profile’ in the dropdown menu.&nbsp;</p></li><li><p>Select ‘Edit Profile’ and add first and last name.</p></li></ul></li></ol><p><span style="color: rgb(0, 0, 0);">If you have any questions about the registration process, please don't hesitate to reach out to us at </span><a target="_blank" rel="noopener noreferrer nofollow" href="mailto:tech@sheddcapital.com"><span style="color: rgb(48, 191, 137);">tech@sheddcapital.com</span></a><span style="color: rgb(0, 0, 0);">.</span></p><p><span style="color: rgb(0, 0, 0);">&nbsp;</span></p><p><span style="color: rgb(0, 0, 0);">Best regards,</span></p><p><span style="color: rgb(0, 0, 0);">The Shedd Capital Team</span></p>`)

const emailBody = ref(defaultEmailMessage.value)
const selectedEmail = ref(null)

function resetEmailBody(){
    emailBody.value = defaultEmailMessage.value
}

async function makeEmailWhitelisted(){
    const token = store.state.auth.token
    const data = {
        allowed_username: selectedEmail.value.allowed_username,
        email_body: emailBody.value
    }
    const result = await whitelistEmail(token, selectedEmail.value.id, data)
    if(result.status == 200){
        $toast.open({
            message: "Successfully whitelisted email address and sent registration email",
            type: 'success',
            duration: 3000
        })
    } else {
        $toast.open({
            message: "Error, could not whitelist email address",
            type: 'error',
            duration: 3000
        })
    }
}


function closeForm(){
    emit('close')
}

</script>